import { render, staticRenderFns } from "./FiltrosLicitacoesPregoeiro.vue?vue&type=template&id=85f93606&"
import script from "./FiltrosLicitacoesPregoeiro.vue?vue&type=script&lang=js&"
export * from "./FiltrosLicitacoesPregoeiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports